import { buildDataTableCols, type DataTableCol } from '@/components/custom/erp/data-table-v2';
import type { NganHang } from '@/types/schemas';

const BANK_COLUMNS: DataTableCol<NganHang>[] = [
  {
    field: 'ma_ngan_hang',
    headerName: 'Mã ngân hàng',
    width: 150,
    valueGetter: row => row.ma_ngan_hang
  },
  {
    field: 'ten_ngan_hang',
    headerName: 'Tên ngân hàng',
    width: 300,
    valueGetter: row => row.ten_ngan_hang
  },
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 150,
    valueGetter: row => row.status,
    renderCell: params => (String(params.row.status) === '1' ? 'Còn sử dụng' : 'Không sử dụng')
  }
];

export const getDataTableColumns = () => buildDataTableCols(BANK_COLUMNS);
